import { PlayCircle } from "lucide-react";

/** Client Portal v2 (2026-09, Phase 1, §4) — candid Behind-the-Scenes media (Mongo + Drive
 * only, see modules/client_bts.py). Now lives as the "From the shoot" subsection at the foot of
 * Review & Delivery. Grid gallery, images render inline via the app's own file proxy; videos
 * show a play badge and open in a new tab. */
export function BtsGallery({ media, fileUrl }) {
  if (!media || media.length === 0) {
    return (
      <p className="text-[13.5px] text-[color:var(--cp-grey-3)]" data-testid="client-portal-bts-empty">Candid behind-the-scenes moments from the shoot will show up here.</p>
    );
  }
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3" data-testid="client-portal-bts-grid">
      {media.map((m) => {
        const isVideo = (m.mime_type || "").startsWith("video/");
        const url = fileUrl(m.id);
        return (
          <a
            key={m.id}
            href={url}
            target="_blank"
            rel="noreferrer"
            data-testid={`client-portal-bts-item-${m.id}`}
            className="group relative aspect-square overflow-hidden border border-[color:var(--cp-surface-line)] bg-white hover:border-black/30 transition-colors block"
          >
            {isVideo ? (
              <div className="h-full w-full flex items-center justify-center bg-black">
                <PlayCircle className="h-8 w-8 text-[color:var(--cp-gold)]" />
              </div>
            ) : (
              <img src={url} alt={m.caption || "Behind the scenes"} className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-300" loading="lazy" decoding="async" />
            )}
            {m.caption && <div className="absolute inset-x-0 bottom-0 p-2 bg-gradient-to-t from-black/80 to-transparent text-[11px] text-white truncate">{m.caption}</div>}
          </a>
        );
      })}
    </div>
  );
}
